import { of as observableOf } from 'rxjs';
import * as i0 from "@angular/core";
export class CustomPreloader {
    preload(route, load) {
        if (route.data && route.data['preload'] === false) {
            return observableOf(null);
        }
        else {
            return load();
        }
    }
}
CustomPreloader.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CustomPreloader_Factory() { return new CustomPreloader(); }, token: CustomPreloader, providedIn: "root" });
